<template>
  <div >
    <Header/>
    <div class="zwB "></div>
    <div class="bodyBG2">
      <div class="curBoxb">
        <BreadCrumb/>
      </div>
      <div class="zcglBa"></div>
      <div class="listPBa">
        <CompanyIntroductionsLeftNav/>
        <div class="listPBr">
          <div class="docTitleB">
            <h1>
              {{$t('company_organization')}}
            </h1>
            <div class="timeB">
              {{$t('belonging_to')}} {{$t('company_introductions')}} {{$t('author')}} {{$t('tajik_securities')}} {{$t('update_time')}}：2020-06-03 14:03:36
            </div>
          </div>
          <div class="docHtmlB">
            <div class=TRS_Editor>
              <div>
                <img :src="company_organization_group" style="border-width: 0px;" alt="塔吉克证券组织架构图" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import Footer from "../components/Footer";
  import Header from "../components/Header";
  import CompanyIntroductionsLeftNav from "../components/CompanyIntroductionsLeftNav";
  import BreadCrumb from "../components/BreadCrumb";
  import {zh_company_organization_group_url,en_company_organization_group_url,ru_company_organization_group_url} from '../application'
  export default {
    components: {BreadCrumb, CompanyIntroductionsLeftNav, Footer,Header},
    computed:{
      company_organization_group:function () {
        if(this.currentLang ==='zh'){
          return zh_company_organization_group_url
        }else if(this.currentLang ==='en'){
          return en_company_organization_group_url
        }else{
          return ru_company_organization_group_url
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style>
    .zwB{
        height: 130px;
    }
</style>